import { createContext } from 'react';


        // =======================================================================
        // Auth context
        // =======================================================================
        const AuthCtx = createContext(null);

export { AuthCtx };
